import { c as _c } from "react/compiler-runtime";
import { BottomSheetBody, BottomSheetFooter, BottomSheetHeader, BottomSheetHeaderTitle, Flex, FlexColumn, ItemAvatar, ItemContent, ItemSide, Separator, Skeleton, SkeletonBlock } from "@opensea/ui-kit";
import { useTranslations } from "use-intl";
import { Item } from "../../../components/Item";
export function CancelOrderFlowSkeleton(t0) {
  const $ = _c(15);
  const {
    count: t1
  } = t0;
  const count = t1 === undefined ? 1 : t1;
  const t = useTranslations("wallet.CancelOrderFlow");
  let t2;
  if ($[0] !== t) {
    t2 = t("cancelOrder");
    $[0] = t;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t2) {
    t3 = <BottomSheetHeader><BottomSheetHeaderTitle>{t2}</BottomSheetHeaderTitle></BottomSheetHeader>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== count) {
    t4 = new Array(count).fill(0).map(_temp);
    $[4] = count;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t4) {
    t5 = <FlexColumn>{t4}</FlexColumn>;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator />;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5) {
    t7 = <BottomSheetBody className="pb-0">{t5}{t6}</BottomSheetBody>;
    $[9] = t5;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <BottomSheetFooter><Flex className="justify-end"><SkeletonBlock className="h-10 w-[120px] rounded" /></Flex></BottomSheetFooter>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== t3 || $[13] !== t7) {
    t9 = <>{t3}{t7}{t8}</>;
    $[12] = t3;
    $[13] = t7;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  return t9;
}
function _temp(_, index) {
  return <Item className="py-2.5" key={index} variant="unstyled"><ItemAvatar size={48}><SkeletonBlock className="size-12 rounded" /></ItemAvatar><ItemContent className="gap-2"><Skeleton className="w-24" /><Skeleton className="w-32" /></ItemContent><ItemSide><Skeleton className="w-16" /><Skeleton className="w-12" /></ItemSide></Item>;
}